import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Bell } from 'lucide-react';
import { Button } from '../components/ui/button';
import CompanyNotificationSettingsPanel from '../components/settings/CompanyNotificationSettingsPanel';

const WorkflowNotificationSettingsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center space-x-4">
          <Button variant="outline" asChild>
            <Link to="/admin" className="flex items-center space-x-2">
              <ArrowLeft className="h-4 w-4" />
              <span>System Settings</span>
            </Link>
          </Button>
          <div>
            <div className="flex items-center gap-2">
              <Bell className="h-6 w-6 text-gray-900 dark:text-gray-100" />
              <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                Workflow Notifications
              </h1>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              Configure who receives completion reports and workflow alerts by email and in-app.
            </p>
          </div>
        </div>
      </div>

      <CompanyNotificationSettingsPanel standalone />
    </div>
  );
};

export default WorkflowNotificationSettingsPage;
